import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** 流式 markdown：每次增量重新渲染；链接新窗口打开 */
export function Markdown({ text }: { text: string }) {
  return (
    <div className="md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _n, ...p }) => <a {...p} target="_blank" rel="noreferrer noopener" />,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
